import { type PropsWithChildren } from 'react';
import { cn } from '@/utils';
export interface FunctionCardProps {
  id: string;
  className?: string;
  layout: 'horizontal' | 'vertical';
  title: string;
  description: string;
  imgSrc: string;
  visibleCountries?: string[];
  hideCountries?: string[];
}
const Horizontal = ({
  className,
  title,
  description,
  imgSrc
}: Omit<FunctionCardProps, 'id' | 'layout'>) => <article className={cn('h-[280px] tablet-lg:h-[330px] flex border border-alternative rounded-lg overflow-hidden', className)} data-sentry-component="Horizontal" data-sentry-source-file="FunctionCard.tsx">
    <div className="flex w-full max-w-[520px] flex-col gap-md px-2xl pb-sm pt-3xl">
      <h4 className="text-heading-xl-extrabold">{title}</h4>
      <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="FunctionCard.tsx">{description}</FunctionCard.Description>
    </div>
    <FunctionCard.Image src={imgSrc} alt={title} data-sentry-element="unknown" data-sentry-source-file="FunctionCard.tsx" />
  </article>;
const Vertical = ({
  className,
  title,
  description,
  imgSrc
}: Omit<FunctionCardProps, 'id' | 'layout'>) => <article className={cn('h-[280px] tablet-lg:h-[330px] flex flex-col items-center border border-alternative rounded-lg overflow-hidden', className)} data-sentry-component="Vertical" data-sentry-source-file="FunctionCard.tsx">
    <div className="flex w-full flex-col gap-sm px-lg pb-md pt-2xl tablet-lg:px-2xl tablet-lg:pb-sm">
      <h4 className="text-heading-lg-extrabold">{title}</h4>
      <FunctionCard.Description data-sentry-element="unknown" data-sentry-source-file="FunctionCard.tsx">{description}</FunctionCard.Description>
    </div>
    <FunctionCard.Image className="max-w-[319px] tablet-lg:max-w-[415px]" src={imgSrc} alt={title} data-sentry-element="unknown" data-sentry-source-file="FunctionCard.tsx" />
  </article>;
const Description = ({
  className,
  children
}: PropsWithChildren<{
  className?: string;
}>) => <p className={cn('whitespace-pre-line text-body-lg-semibold text-neutral', className)} data-sentry-component="Description" data-sentry-source-file="FunctionCard.tsx">
    {children}
  </p>;
const Image = ({
  className,
  src,
  alt
}: {
  className?: string;
  src: string;
  alt?: string;
}) => <img src={src} alt={alt} className={cn('min-w-0 size-full object-cover object-center', className)} data-sentry-component="Image" data-sentry-source-file="FunctionCard.tsx" />;
export const FunctionCard = {
  Horizontal,
  Vertical,
  Description,
  Image
};